(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sqsAssets = window.sqsAssets || {};

  function initGlitter(canvas) {
    var ctx = canvas.getContext('2d');
    var parent = canvas.parentElement;
    var particles = [];

    var knifeImg = new Image();
    if (sqsAssets.knife) knifeImg.src = sqsAssets.knife;
    var candleImg = new Image();
    if (sqsAssets.candle) candleImg.src = sqsAssets.candle;
    var maskImg = new Image();
    if (sqsAssets.mask) maskImg.src = sqsAssets.mask;

    function resize() {
      canvas.width = parent.offsetWidth;
      canvas.height = parent.offsetHeight;
    }

    function pumpkinPath(ctx, s) {
      ctx.beginPath();
      ctx.ellipse(0, s * 0.15, s * 1.0, s * 0.85, 0, 0, Math.PI * 2);
      ctx.rect(-s * 0.12, -s * 1.15, s * 0.24, s * 0.5);
      ctx.closePath();
    }

    function drawSilhouette(img, x, y, s, rot, alpha) {
      if (!img.complete || !img.naturalWidth) return;
      var ratio = img.naturalWidth / img.naturalHeight;
      var h = s * 2.4;
      var w = h * ratio;
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(rot);
      ctx.globalAlpha = alpha;
      ctx.drawImage(img, -w / 2, -h / 2, w, h);
      ctx.restore();
    }

    var TYPES = ['knife', 'pumpkin', 'candle', 'scream'];

    function spawn(n) {
      for (var i = 0; i < n; i++) {
        var type = TYPES[Math.floor(Math.random() * TYPES.length)];
        particles.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          r: 6 + Math.random() * 6,
          speedY: 0.1 + Math.random() * 0.18,
          drift: (Math.random() - 0.5) * 0.25,
          rot: Math.random() * Math.PI * 2,
          rotSpeed: (Math.random() - 0.5) * 0.012,
          phase: Math.random() * Math.PI * 2,
          speed: 0.02 + Math.random() * 0.05,
          type: type
        });
      }
    }

    var raf;
    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.y += p.speedY;
        p.x += p.drift;
        p.phase += p.speed;
        if (p.y > canvas.height + 14) { p.y = -14; p.x = Math.random() * canvas.width; }

        var flicker = 0.55 + 0.45 * Math.abs(Math.sin(p.phase));
        p.rot += p.rotSpeed;

        if (p.type === 'candle') {
          drawSilhouette(candleImg, p.x, p.y, p.r, p.rot * 0.15, 0.8 + 0.2 * flicker);
        } else if (p.type === 'scream') {
          drawSilhouette(maskImg, p.x, p.y, p.r, p.rot * 0.15, 0.55 + 0.35 * flicker);
        } else if (p.type === 'knife') {
          drawSilhouette(knifeImg, p.x, p.y, p.r, p.rot, 0.55 + 0.4 * flicker);
        } else {
          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot);
          ctx.globalAlpha = 0.55 + 0.4 * flicker;
          ctx.fillStyle = '#e0801f';
          pumpkinPath(ctx, p.r);
          ctx.fill();
          ctx.restore();
        }
      }
      ctx.globalAlpha = 1;
      raf = requestAnimationFrame(draw);
    }

    resize();
    spawn(Math.max(12, Math.floor((canvas.width * canvas.height) / 15000)));
    if (!reduce) draw(); else { draw(); cancelAnimationFrame(raf); }

    window.addEventListener('resize', resize);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) cancelAnimationFrame(raf); else if (!reduce) draw();
    });
  }

  function initCountdown(el) {
    var targetStr = el.getAttribute('data-target');
    if (!targetStr) return;
    var target = new Date(targetStr).getTime();
    if (isNaN(target)) return;

    var label = el.querySelector('.sqs-countdown__label');
    var labelDefault = label ? label.textContent : '';
    var liveText = el.getAttribute('data-live-text') || "It's happening — go shop!";
    var dEl = el.querySelector('[data-cd="days"]');
    var hEl = el.querySelector('[data-cd="hrs"]');
    var mEl = el.querySelector('[data-cd="mins"]');
    var sEl = el.querySelector('[data-cd="secs"]');
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var timer;

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        if (dEl) dEl.textContent = '00';
        if (hEl) hEl.textContent = '00';
        if (mEl) mEl.textContent = '00';
        if (sEl) sEl.textContent = '00';
        el.classList.add('is-live');
        if (label) label.textContent = liveText;
        clearInterval(timer);
        return;
      }
      var days = Math.floor(diff / 86400000);
      var hrs = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      if (dEl) dEl.textContent = pad(days);
      if (hEl) hEl.textContent = pad(hrs);
      if (mEl) mEl.textContent = pad(mins);
      if (sEl) sEl.textContent = pad(secs);
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  // NOTE: the VIP gate's password field used to be handled entirely
  // by client-side JS here (initGate), which faked a password check
  // and then tried to redirect into the store — but the store was
  // still really behind Shopify's own separate password protection,
  // so that redirect just bounced people right back to this same
  // page. The gate's <form> now submits for real via Shopify's
  // `storefront_password` form (see sections/sqs-vip-access.liquid),
  // so no JS handling is needed for it here any more — removed to
  // avoid it swallowing the real submit with preventDefault().

  function boot() {
    document.querySelectorAll('canvas.sqs-glitter').forEach(initGlitter);
    document.querySelectorAll('.sqs-countdown[data-target]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
